/**
 * Button CSS Rules Generator
 *
 * Generate CSS rules for button control group attributes.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { applyFilters } from '@wordpress/hooks';

import type { ButtonValues } from '../types';

/**
 * Generate CSS rules for button values
 */
export const generateButtonCSSRules = (
	values: ButtonValues,
): Record< string, string > => {
	const styles: Record< string, string > = {};

	// Background color
	if ( values.backgroundColor ) {
		styles[ 'background-color' ] = values.backgroundColor;
	}

	// Text color
	if ( values.textColor ) {
		styles[ 'color' ] = values.textColor;
	}

	/**
	 * Filter button CSS rules
	 *
	 * Allows modification of generated button CSS rules.
	 * Pro plugin can extend this to add gradient, box-shadow, spacing, typography, and border styles.
	 *
	 * @since 1.0.0
	 *
	 * @param {Record<string, string>} styles - Generated CSS rules
	 * @param {ButtonValues} values - Button control values
	 */
	return applyFilters(
		'redfox_thank_you.button.css_rules',
		styles,
		values,
	) as Record< string, string >;
};
